export class MyDocCollabsConstants{
    public static readonly MyDocCollabs_TopBarTitle: string = 'My Doc Collabs';
    public static readonly MyDocCollabs_CheckBoxHoverToolTip: string = 'By default only Document Versions in the Collaboration Phase are displayed. Check this check box to display all the Document Version where you are assigned as Author or Collaborator, regardless of any other condition.';
    public static readonly MyDocCollabs_ShowAllLabel: string = 'Show All';
    public static readonly MyDocCollabs_ShowInformationIconCheckbox: boolean = true;
    public static readonly MyDocCollabs_IsIncludeAll: boolean = false;
}
